import {useGeneralProvider} from 'brand/app/components/_app-config/GeneralProvider';

/**
 * useReturnAuthorizationMgr custom hook
 */
export default function useReturnAuthorizationMgr() {
	const {managerRepository} = useGeneralProvider();

	return managerRepository.getReturnAuthorizationMgr();
};
